export enum rolesBdc {
  admin = 'admin_bdc',
  gestionnaire = 'gestionnaire_bdc',
  supergestionnaire = 'supergestionnaire_bdc',
}
